export class updateStatus  {
    exceptionId!: number;
    status!: string;
    comment!: string;
    owner!: string;
    exceptionType!: string;
    updatedBy!: string;
  }

  export class Loading {
    isGridLoading!: boolean;
    isTradeDataLoading!: boolean;
    isOrderDataLoading!: boolean;
    isRouteDataLoading!: boolean;
    isExceptionLoading!: boolean;
    isClientDataStatus!: boolean;
  }